import { useParams } from 'react-router';
import NewProgramDisenrollmentReasonForm from './new';

export default function EditActivityType() {
  const { disenrollmentReason = '' } = useParams();

  return <NewProgramDisenrollmentReasonForm isEdit currentReason={disenrollmentReason} />;
}
